var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "interface-essential-navigation-right-circle-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 12.19,
    width: 1.52,
    height: 7.62,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.52,
    y: 19.81,
    width: 1.53,
    height: 3.05,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.52,
    y: 9.14,
    width: 1.53,
    height: 3.05,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.05,
    y: 22.86,
    width: 1.52,
    height: 3.04,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.05,
    y: 6.09,
    width: 1.52,
    height: 3.05,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.57,
    y: 25.9,
    width: 1.53,
    height: 1.53,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.57,
    y: 4.57,
    width: 1.53,
    height: 1.52,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 27.43,
    width: 3.04,
    height: 1.52,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.38 12.19 22.86 12.19 22.86 10.67 21.33 10.67 21.33 9.14 19.81 9.14 19.81 7.62 18.29 7.62 18.29 10.67 9.14 10.67 9.14 12.19 7.62 12.19 7.62 13.71 6.1 13.71 6.1 21.33 7.62 21.33 7.62 22.86 10.67 22.86 10.67 24.38 13.71 24.38 13.71 22.86 12.19 22.86 12.19 21.33 10.67 21.33 10.67 19.81 12.19 19.81 12.19 18.29 18.29 18.29 18.29 21.33 19.81 21.33 19.81 19.81 21.33 19.81 21.33 18.29 22.86 18.29 22.86 16.76 24.38 16.76 24.38 15.24 25.91 15.24 25.91 13.71 24.38 13.71 24.38 12.19",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 3.05,
    width: 3.04,
    height: 1.52,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.14,
    y: 28.95,
    width: 3.05,
    height: 1.53,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.14,
    y: 1.52,
    width: 3.05,
    height: 1.53,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.19,
    y: 30.48,
    width: 7.62,
    height: 1.52,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.19,
    width: 7.62,
    height: 1.52,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.81,
    y: 28.95,
    width: 3.05,
    height: 1.53,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.81,
    y: 1.52,
    width: 3.05,
    height: 1.53,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.86,
    y: 27.43,
    width: 3.05,
    height: 1.52,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.86,
    y: 3.05,
    width: 3.05,
    height: 1.52,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.91,
    y: 25.9,
    width: 1.52,
    height: 1.53,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.91,
    y: 4.57,
    width: 1.52,
    height: 1.52,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.43,
    y: 22.86,
    width: 1.52,
    height: 3.04,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.43,
    y: 6.09,
    width: 1.52,
    height: 3.05,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.95,
    y: 19.81,
    width: 1.53,
    height: 3.05,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.95,
    y: 9.14,
    width: 1.53,
    height: 3.05,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.48,
    y: 12.19,
    width: 1.52,
    height: 7.62,
    fill: "#f2f2f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f66064c0b212a6e3dad222c6e1582af0.svg";
export { ForwardRef as ReactComponent };